import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ButtonComp = (props) => {
    const { item, className } = props;
    const { icon = {}, settings = {}, attr = {} } = item;
    const { icon: iconSvg = {} } = icon;
    const hasIcon = settings.buttonType !== 'text-only' && icon.icon;

    return (
        <a href="#" className={`dorik-btn ${className}`}>
            {hasIcon && (
                <FontAwesomeIcon
                    fixedWidth
                    className="icon"
                    icon={[iconSvg.prefix, iconSvg.iconName]}
                />
            )}
            {
                props.children
                // <Pell
                //     actions={[]}
                //     address={address}
                //     pellOptions={pellOptions}
                //     onChange={handleTextChange}
                //     style={{ display: 'inline-block' }}
                // >
                //     {props.children}
                // </Pell>
            }
        </a>
    );
};

export default ButtonComp;
